module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Crimen en la Ciudad de México","short_name":"HoyoDeCrimen","icon":"src/images/logo.png","start_url":"/","lang":"es","background_color":"#f7f0eb","display":"standalone","localize":[{"start_url":"/en/","lang":"en","name":"Mexico City Crime","short_name":"CDMX Crime"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"1100fb79d243d2b61455cadfa8c48a20"},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"redirect":false,"localeJsonSourceName":"translations","languages":["en","es"],"defaultLanguage":"es","siteUrl":"https://hoyodecrimen.com","i18nextOptions":{"interpolation":{"escapeValue":false},"keySeparator":false,"nsSeparator":false}},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
